import { get } from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

export function getTranslatedString(value, locale = 'fr') {
    return get(value, ['translatedString', locale], value);
}

@Component({
    props: {
        tag: {
            required: false,
            type: String,
        },
        value: [Number, String, Object],
        values: {
            required: false,
            type: [Array, Object],
        },
    },
})
export class LocalizedString extends Vue {
    public tag: string;
    public value: string | { translatedString: Record<string, string> };
    public values: any[] | Record<string, any>;

    public render(createElement) {
        const key = getTranslatedString(this.value, 'fr');
        const message = this.$te(key) ? this.$t(key, this.values) : key;

        return createElement(this.tag || 'span', message);
    }
}
